export default "__VITE_ASSET__Bpx9BtTV__"